import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSquareArrowRightRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5 4.5c-.275 0-.5.225-.5.5v10c0 .275.225.5.5.5h10c.275 0 .5-.225.5-.5V5c0-.275-.225-.5-.5-.5zM3 5c0-1.103.897-2 2-2h10c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2zm7.781 7.781a.75.75 0 0 1-1.06-1.06l.97-.968H7.5a.75.75 0 0 1-.75-.75c0-.415.334-.75.75-.75h3.19l-.968-.969a.75.75 0 0 1 1.06-1.06l2.25 2.251a.747.747 0 0 1 0 1.06l-2.25 2.25z" })
});
export default SvgSquareArrowRightRegularIcon;
